import * as React from "react";
const SvgSmallArrow = (props) => /* @__PURE__ */ React.createElement("svg", { width: 7, height: 4, viewBox: "0 0 7 4", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6.6665 3.3335L3.33317 0.000162959L-0.000162363 3.3335L6.6665 3.3335Z", fill: "white" }));
export default SvgSmallArrow;
